import { render, staticRenderFns } from "./SocSohScatter.vue?vue&type=template&id=21ef906a&"
import script from "./SocSohScatter.vue?vue&type=script&lang=js&"
export * from "./SocSohScatter.vue?vue&type=script&lang=js&"
import style0 from "./SocSohScatter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports